import editIcon from "../assets/editIcon.png";

import editItemIcon from "../assets/editiItem.png";
import duplicateIcon from "../assets/duplicateIcon.png";
import downloadOrangeIcon from "../assets/downloadIconOrange.png";
import deleteIcon from "../assets/deleteIcon.png";
import { useNavigate } from "react-router-dom";

export const OptionMenu = ({ setter, orderId, setIsModalOpen }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative z-[1000]">
        <div className="absolute z-[1000] left-0 w-48 bg-mediumGray border rounded-lg shadow-lg p-4">
          <ul className="py-2 mt-2 text-left text-boldGray">
            <li className="px-2 py-2 bg-white rounded-md mt-2 cursor-pointer">
              <button onClick={() => navigate(`/pedidos/edit/${orderId}`)}>
                <div className="flex">
                  <img
                    src={editItemIcon}
                    className="mr-2 w-[17px] h-[17px]"
                    alt="ícone para edição"
                  />
                  Editar
                </div>
              </button>
            </li>
            {/* <li className="px-2 py-2 bg-white rounded-md mt-2 cursor-pointer">
              <div className="flex">
                <img
                  src={duplicateIcon}
                  className="mr-2 w-[17px] h-[17px]"
                  alt="ícone para duplicar"
                />
                Duplicar
              </div>
            </li>
            <li className="px-2 py-2 bg-white rounded-md mt-2 cursor-pointer">
              <div className="flex">
                <img
                  src={downloadOrangeIcon}
                  className="mr-2 w-[17px] h-[17px]"
                  alt="ícone para download"
                />
                Download
              </div>
            </li> */}
            <li className="px-2 py-2 bg-white rounded-md mt-2 cursor-pointer">
              <button onClick={() => setIsModalOpen(true)}>
                <div className="flex">
                  <img
                    src={deleteIcon}
                    className="mr-2 w-[17px] h-[17px]"
                    alt="ícone para excluir"
                  />
                  Excluir
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div
        id="modal-bg"
        className="fixed h-screen w-screen z-[900] inset-0 bg-transparent"
        onClick={() => setter(false)}
      ></div>
    </>
  );
};

export default OptionMenu;
